import React from "react";
import Tool from "./Tool";

export default class RectTool extends Tool {
  constructor(props) {
    super(props, 20, 20, "rect", true);
  }

  renderTool() {
    return (
      <rect x={0} y={0} width={20} height={20} />
    );
  }

  getCursor() {
    return 'crosshair'
  }

}



// WEBPACK FOOTER //
// ./src/components/ui/tools/RectTool.js